<div class="container py-4">
  <div class="mb-3">
    <h2 class="mb-1">Aprovação de Seção de Serviço</h2>
    <div class="text-muted" *ngIf="code">Código: <strong>{{ code }}</strong></div>
  </div>

  <div *ngIf="loading" class="d-flex align-items-center">
    <div class="spinner-border text-primary" role="status"></div>
    <span class="ms-2">Carregando...</span>
  </div>

  <div *ngIf="!loading && !section" class="alert alert-danger">
    Não foi possível carregar os dados da seção.
  </div>

  <div *ngIf="!loading && section">
    <div class="card mb-3">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div><strong>Seção:</strong> {{ section.description || ('#' + section.id) }}</div>
            <div><strong>Status:</strong> {{ section.status || 'Pendente' }}</div>
          </div>
          <div class="col-md-6">
            <div><strong>Total Serviços:</strong> {{ formatMoney(servicesTotal) }}</div>
            <div><strong>Total Itens:</strong> {{ formatMoney(itemsTotal) }}</div>
            <div><strong>Total Geral:</strong> {{ formatMoney(grandTotal) }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-3" *ngIf="(section.services?.length || 0) > 0">
      <div class="card-header">
        Serviços ({{ section.services?.length || 0 }})
      </div>
      <div class="card-body p-0">
        <table class="table table-sm mb-0">
          <thead>
            <tr>
              <th>#</th>
              <th>Descrição</th>
              <th class="text-end">Qtd</th>
              <th class="text-end">Vlr Unit.</th>
              <th class="text-end">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of section.services; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ s.description }}</td>
              <td class="text-end">{{ s.quantity }}</td>
              <td class="text-end">{{ formatMoney(s.unitValue) }}</td>
              <td class="text-end"><strong>{{ formatMoney(s.totalValue) }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card mb-3" *ngIf="(section.items?.length || 0) > 0">
      <div class="card-header">
        Itens ({{ section.items?.length || 0 }})
      </div>
      <div class="card-body p-0">
        <table class="table table-sm mb-0">
          <thead>
            <tr>
              <th>#</th>
              <th>Descrição</th>
              <th class="text-end">Qtd</th>
              <th class="text-end">Vlr Unit.</th>
              <th class="text-end">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let it of section.items; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ it.description }}</td>
              <td class="text-end">{{ it.quantity }}</td>
              <td class="text-end">{{ formatMoney(it.unitValue) }}</td>
              <td class="text-end"><strong>{{ formatMoney(it.totalValue) }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-success w-100"
      (click)="aprovar()"
      [disabled]="approving">
      {{ approving ? 'Aprovando...' : 'Aprovar' }}
    </button>
  </div>
</div>
